<template>
  <form>
    
    <div class="row">
      <div class="col-lg-4">
        <h4 class="card-title">{{$t('medium_grant.technical__2_organisational_info')}}</h4>
        <div class="form-group">
          <label for="regionSelect">{{$t('medium_grant.technical__2_org_legal_name')}}</label>
          <textarea
            class="form-control"
            name="technical.orgLegalName"
            v-model="GrantForm.model.cnorgnization.orgLegalName"
            :error="getError('cnorgnization.orgLegalName')"
            v-validate="'required'"
            :data-vv-as="$t('medium_grant.technical__2_org_legal_name')"
            :label="$t('medium_grant.technical__2_org_legal_name')"
            :placeholder="$t('medium_grant.technical__2_org_legal_name')"
            :disabled="GrantForm.disableConcept"
          >
          </textarea>
        </div>
        <div class="form-group">
          <label for="regionSelect">{{$t('medium_grant.technical__2_org_short_name')}}</label>
          <textarea
            class="form-control"
            name="technical.orgShortName"
            v-model="GrantForm.model.cnorgnization.orgShortName"
            :label="$t('medium_grant.technical__2_org_short_name')"
            :placeholder="$t('medium_grant.technical__2_org_short_name')"
            :disabled="GrantForm.disableConcept"
          >
          </textarea>
        </div>
        <div class="form-group">
          <label for="regionSelect">{{$t('medium_grant.technical__2_website')}}</label>
          <textarea
            class="form-control"
            name="technical.website"
            v-model="GrantForm.model.cnorgnization.website"
            :label="$t('medium_grant.technical__2_website')"
            :placeholder="$t('medium_grant.technical__2_website')"
            :disabled="GrantForm.disableConcept"
          >
          </textarea>
        </div>
        <div class="form-group">
          <label for="regionSelect">{{$t('medium_grant.technical__2_mailing')}}</label>
          <textarea
            class="form-control"
            name="technical.mailing"
            v-model="GrantForm.model.cnorgnization.mailing"
            :error="getError('cnorgnization.mailing')"
            v-validate="'required'"
            :data-vv-as="$t('medium_grant.technical__2_mailing')"
            :label="$t('medium_grant.technical__2_mailing')"
            :placeholder="$t('medium_grant.technical__2_mailing')"
            :disabled="GrantForm.disableConcept"
          >
          </textarea>
        </div>
        <div class="form-group">
          <label for="regionSelect">{{$t('medium_grant.technical__2_physical')}}</label>
          <textarea
            class="form-control"
            name="technical.physical"
            v-model="GrantForm.model.cnorgnization.physical"
            :error="getError('cnorgnization.physical')"
            v-validate="'required'"
            :data-vv-as="$t('medium_grant.technical__2_physical')"
            :label="$t('medium_grant.technical__2_physical')"
            :placeholder="$t('medium_grant.technical__2_physical')"
            :disabled="GrantForm.disableConcept"
          >
          </textarea>
        </div>

        <h3 class="card-title">{{$t('medium_grant.technical__2_project_lead_contact_title')}}</h3>
        <p class="small">{{$t('medium_grant.technical__2_project_lead_contact_sub')}}</p>
        <div class="form-group">
          <label for="regionSelect">{{$t('medium_grant.general__name')}}</label>
          <textarea
            class="form-control"
            name="technical.leadName"
            v-model="GrantForm.model.cnorgnization.leadName"
            :error="getError('cnorgnization.leadName')"
            v-validate="'required'"
            :data-vv-as="$t('medium_grant.general__name')"
            :label="$t('medium_grant.general__name')"
            :placeholder="$t('medium_grant.general__name')"
            :disabled="GrantForm.disableConcept"
          >
          </textarea>
        </div>
        <div class="form-group">
          <label for="regionSelect">{{$t('medium_grant.general__email')}}</label>
          <textarea
            class="form-control"
            name="technical.leadEmail"
            v-model="GrantForm.model.cnorgnization.leadEmail"
            :error="getError('cnorgnization.leadEmail')"
            v-validate="'required'"
            :data-vv-as="$t('medium_grant.general__email')"
            :label="$t('medium_grant.general__email')"
            :placeholder="$t('medium_grant.general__email')"
            :disabled="GrantForm.disableConcept"
          >
          </textarea>
        </div>
        <div class="form-group">
           <label for="regionSelect">{{$t('medium_grant.general__telephone')}}</label>
          <textarea
            class="form-control"
            name="technical.leadPhone"
            v-model="GrantForm.model.cnorgnization.leadPhone"
            :error="getError('cnorgnization.leadPhone')"
            v-validate="'required'"
            :data-vv-as="$t('medium_grant.general__telephone')"
            :label="$t('medium_grant.general__telephone')"
            :placeholder="$t('medium_grant.general__telephone')"
            :disabled="GrantForm.disableConcept"
          >
          </textarea>
        </div>
        <h3 class="card-title">{{$t('medium_grant.technical__2_org_chief_title')}}</h3>
        <p class="small">{{$t('medium_grant.technical__2_org_chief_sub')}}</p>
        <div class="form-group">
          <label for="regionSelect">{{$t('medium_grant.general__name')}}</label>
          <textarea
            class="form-control"
            name="technical.chiefName"
            v-model="GrantForm.model.cnorgnization.chiefName"
            :error="getError('cnorgnization.chiefName')"
            v-validate="'required'"
            :data-vv-as="$t('medium_grant.general__name')"
            :label="$t('medium_grant.general__name')"
            :placeholder="$t('medium_grant.general__name')"
            :disabled="GrantForm.disableConcept"
          >
          </textarea>
        </div>
        <div class="form-group">
          <label for="regionSelect">{{$t('medium_grant.general__email')}}</label>
          <textarea
            class="form-control"
            name="technical.chiefEmail"
            v-model="GrantForm.model.cnorgnization.chiefEmail"
            :error="getError('cnorgnization.chiefEmail')"
            v-validate="'required'"
            :data-vv-as="$t('medium_grant.general__email')"
            :label="$t('medium_grant.general__email')"
            :placeholder="$t('medium_grant.general__email')"
            :disabled="GrantForm.disableConcept"
          >
          </textarea>
        </div>
        <div class="form-group">
          <label for="regionSelect">{{$t('medium_grant.general__telephone')}}</label>
          <textarea
            class="form-control"
            name="technical.chiefPhone"
            v-model="GrantForm.model.cnorgnization.chiefPhone"
            :error="getError('cnorgnization.chiefPhone')"
            v-validate="'required'"
            :data-vv-as="$t('medium_grant.general__telephone')"
            :label="$t('medium_grant.general__telephone')"
            :placeholder="$t('medium_grant.general__telephone')"
            :disabled="GrantForm.disableConcept"
          >
          </textarea>
        </div>
         <!--check if IUCN member -->
        <div class="form-group">
        <p class="small">Is an IUCN member?<i class="hover-instruction"></i></p>
        <div class="form-check form-check-radio form-check-inline">
          <radio name="iucnMember" inline value="true" v-model="GrantForm.model.cnorgnization.iucnMember" :disabled="GrantForm.disableConcept">
            {{$t('medium_grant.general__yes')}}
          </radio>
          <radio name="iucnMember" inline value="false" v-model="GrantForm.model.cnorgnization.iucnMember" :disabled="GrantForm.disableConcept">
            {{$t('medium_grant.general__no')}}
          </radio>
        </div>
        </div>
                <!-- Other Projects -->
        <h3 class="card-title">{{$t('applications.section_title__other_projects')}}</h3>
        <div>
        <p class="small">{{$t('applications.field_title_in_other_projects_one')}}<i class="hover-instruction"></i></p>
        <div class="form-check form-check-radio form-check-inline">
          <radio name="otherProjectsOne" inline value="true" v-model="GrantForm.model.cnorgnization.otherProjectsOne" :disabled="GrantForm.disableConcept">
            {{$t('medium_grant.general__yes')}}
          </radio>
          <radio name="otherProjectsOne" inline value="false" v-model="GrantForm.model.cnorgnization.otherProjectsOne" :disabled="GrantForm.disableConcept">
            {{$t('medium_grant.general__no')}}
          </radio>
        </div>
        </div>

        <div>
        <p class="small">{{$t('applications.field_title_in_other_projects_two')}}<i class="hover-instruction"></i></p>
        <div class="form-check form-check-radio form-check-inline">
          <radio name="otherProjectsTwo" inline value="true" v-model="GrantForm.model.cnorgnization.otherProjectsTwo" :disabled="GrantForm.disableConcept">
            {{$t('medium_grant.general__yes')}}
          </radio>
          <radio name="otherProjectsTwo" inline value="false" v-model="GrantForm.model.cnorgnization.otherProjectsTwo" :disabled="GrantForm.disableConcept">
            {{$t('medium_grant.general__no')}}
          </radio>
        </div>
        </div>

        <div v-if="GrantForm.model.cnorgnization.otherProjectsTwo == 'true'">
        <label>Please enter the grant Id</label>
        <base-input>
            <textarea
              class="form-control"
              :placeholder="'Please enter the grant Id'"
              v-model="GrantForm.model.cnorgnization.otherGrantId"
              :disabled="GrantForm.disableConcept"
            >
            </textarea>
        </base-input>   
        </div>

        <div>
        <p class="small">{{$t('applications.field_title_in_other_projects_three')}}<i class="hover-instruction"></i></p>
        <div class="form-check form-check-radio form-check-inline">
          <radio name="otherProjectsThree" inline value="true" v-model="GrantForm.model.cnorgnization.otherProjectsThree" :disabled="GrantForm.disableConcept">
            {{$t('medium_grant.general__yes')}}
          </radio>
          <radio name="otherProjectsThree" inline value="false" v-model="GrantForm.model.cnorgnization.otherProjectsThree" :disabled="GrantForm.disableConcept">
            {{$t('medium_grant.general__no')}}
          </radio>
        </div>
        </div>
        <div v-if="GrantForm.model.cnorgnization.otherProjectsThree == 'true'">
        <label>Please enter the name of the grant-mechanism</label>
        <base-input>
            <textarea
              class="form-control"
              :placeholder="'Please enter the name of the grant-mechanism'"
              v-model="GrantForm.model.cnorgnization.grantMechanism"
              :label="'Please enter the name of the grant-mechanism'"
              :disabled="GrantForm.disableConcept"
            >
            </textarea>
        </base-input>   
        </div>
        <!--other projects end-->
      </div>
      <div class="col-lg-1"></div>
      <div class="col-lg-7">
        <h3 class="card-title">{{$t('medium_grant.technical__2_org_type_lead_aplicant')}}</h3>
        <p class="small">{{$t('medium_grant.technical__2_org_type_aplicant_sub')}}</p>
        <div>
          <label v-if="getError('organisationType')" class="text-danger">{{getError('organisationType')}}</label>
          <radio name="organisationType"
                 inline
                 value="government_agency"
                 v-validate="'required'"
                 :data-vv-as="$t('general.field')"
                 v-model="GrantForm.model.cnorgnization.organisationType"
                 :disabled="GrantForm.disableConcept"
          >
            {{$t('page_user.profile__government_agency')}}
          </radio>
          <radio name="organisationType" inline value="protected_conserved_area" v-model="GrantForm.model.cnorgnization.organisationType" :disabled="GrantForm.disableConcept">
            {{$t('page_user.profile__protected_conserved_area')}}
          </radio>
          <radio name="organisationType" inline value="civil_society_ngo" v-model="GrantForm.model.cnorgnization.organisationType" :disabled="GrantForm.disableConcept">
            {{$t('page_user.profile__civil_society_ngo')}}
          </radio>
          <radio name="organisationType" inline value="local_community_cbo" v-model="GrantForm.model.cnorgnization.organisationType" :disabled="GrantForm.disableConcept">
            {{$t('page_user.profile__local_community_cbo')}}
          </radio>
          <radio name="organisationType" inline value="small_medium_enterprise_sme" v-model="GrantForm.model.cnorgnization.organisationType" :disabled="GrantForm.disableConcept">
            {{$t('page_user.profile__small_medium_enterprise_sme')}}
          </radio>
          <radio name="organisationType" inline value="european_member" v-model="GrantForm.model.cnorgnization.organisationType" :disabled="GrantForm.disableConcept">
            {{$t('page_user.profile__european_member')}}
          </radio>
          <radio name="organisationType" inline value="oecd_member" v-model="GrantForm.model.cnorgnization.organisationType" :disabled="GrantForm.disableConcept">
            {{$t('page_user.profile__oecd')}}
          </radio>
          <radio name="organisationType" inline value="regional_org" v-model="GrantForm.model.cnorgnization.organisationType" :disabled="GrantForm.disableConcept">
            {{$t('page_user.profile__regional_org')}}
          </radio>
          <radio name="organisationType" inline value="international_org" v-model="GrantForm.model.cnorgnization.organisationType" :disabled="GrantForm.disableConcept">
            {{$t('page_user.profile__international_org')}}
          </radio>
          <radio name="organisationType" inline value="other" v-model="GrantForm.model.cnorgnization.organisationType" :disabled="GrantForm.disableConcept">
            {{$t('page_user.profile__other')}}
          </radio>
        </div>
        <base-input>
            <textarea
              class="form-control"
              :placeholder="$t('page_user.profile__other_specify')"
              v-model="GrantForm.model.cnorgnization.organisationTypeOther"
              :disabled="GrantForm.disableConcept"
            >
            </textarea>
        </base-input>
        <p class="mt-2 mb-4">{{$t('page_user.profile__organisation_type_note')}}</p>

        <label>{{$t('medium_grant.technical__2_org_history_mission')}}</label>
        <base-input>
            <textarea
              class="form-control"
              :placeholder="$t('medium_grant.general__write_here')"
              v-model="GrantForm.model.cnorgnization.orgHistoryMission"
              :disabled="GrantForm.disableConcept"
            >
            </textarea>
        </base-input>
        <upload-file v-if="GrantForm.initialized" v-model="GrantForm.files.technical.cnOgFullfilmentEligibility" :is-editable="GrantForm.isEditable && !GrantForm.disableConcept" :file-data="GrantForm.files.technical.cnOgFullfilmentEligibility" :size-limit="GrantForm.fileSizeLimit" section="technical.cnOgFullfilmentEligibility" type="cn" @file="fileAdded"></upload-file>
<div class="mt-4"></div>
    <!-- documents-->
    <div>
      
      <h3 class="card-title">Due diligence questionnaire and supporting documents</h3>
          <div class="border-bottom border-light">
            <p class="medium">{{$t('medium_grant_cn.document_upload_due_diligence_questionnaire')}}</p>
          <a :href="downloadFiles[0][$i18n.locale]" class="btn btn-simple btn-primary" :disabled="GrantForm.disableConcept">
                {{$t('small_technical_grants.document_upload__download_template_button_title')}} <i class="tim-icons icon-cloud-download-93 ml-2"></i>
              </a>
            <div class="inline my-2">
          
          <upload-file v-if="GrantForm.initialized" v-model="GrantForm.files.technical.cnDueDiligence" :is-editable="GrantForm.isEditable && !GrantForm.disableConcept" :file-data="GrantForm.files.technical.cnDueDiligence" :size-limit="GrantForm.fileSizeLimit" section="technical.cnDueDiligence" type="cn" @file="fileAdded"></upload-file>

            </div>
          </div>

          <div class="border-bottom border-light">
            <div class="inline my-2">
          <p class="medium">{{$t('medium_grant_cn.document_upload_lead_applicant_declaration_duly_signed')}}</p>
          <upload-file v-if="GrantForm.initialized" v-model="GrantForm.files.technical.cnLeadApplicantDeclaration" :is-editable="GrantForm.isEditable && !GrantForm.disableConcept" :file-data="GrantForm.files.technical.cnLeadApplicantDeclaration" :size-limit="GrantForm.fileSizeLimit" section="technical.cnLeadApplicantDeclaration" type="cn" @file="fileAdded"></upload-file>
          </div>
          </div>

          <div class="border-bottom border-light">
            <div class="inline my-2">
          <p class="medium">{{$t('medium_grant_cn.document_upload_testifying_financial_capacity_applicant')}}</p>
          <upload-file v-if="GrantForm.initialized" v-model="GrantForm.files.technical.cnTestifyingFinancialCapacity" :is-editable="GrantForm.isEditable && !GrantForm.disableConcept" :file-data="GrantForm.files.technical.cnTestifyingFinancialCapacity" :size-limit="GrantForm.fileSizeLimit" section="technical.cnTestifyingFinancialCapacity" type="cn" @file="fileAdded"></upload-file>
          </div>
          </div>

          <div class="border-bottom border-light">
            <div class="inline my-2">
          <p class="medium">{{$t('medium_grant_cn.document_upload_mandate_coapplicant_duly_signed')}}</p>
          <upload-file v-if="GrantForm.initialized" v-model="GrantForm.files.technical.cnMandateCoapplicantDulySigned" :is-editable="GrantForm.isEditable && !GrantForm.disableConcept" :file-data="GrantForm.files.technical.cnMandateCoapplicantDulySigned" :size-limit="GrantForm.fileSizeLimit" section="technical.cnMandateCoapplicantDulySigned" type="cn" @file="fileAdded"></upload-file>
          </div>
          </div>

          <div class="border-bottom border-light">
            <div class="inline my-2">
          <p class="medium">{{$t('medium_grant_cn.document_upload_lead_applicant_due_diligence_and_financial_capacity_questionnaire')}}</p>
          <upload-file v-if="GrantForm.initialized" v-model="GrantForm.files.technical.cnLeadApplicantDueDiligenceAndFinancialCapacityQuestionnaire" :is-editable="GrantForm.isEditable && !GrantForm.disableConcept" :file-data="GrantForm.files.technical.cnLeadApplicantDueDiligenceAndFinancialCapacityQuestionnaire" :size-limit="GrantForm.fileSizeLimit" section="technical.cnLeadApplicantDueDiligenceAndFinancialCapacityQuestionnaire" type="cn" @file="fileAdded"></upload-file>
          </div>
          </div>

          <div class="border-bottom border-light">
            <div class="inline my-2">
          <p class="medium">{{$t('medium_grant_cn.document_upload_coapplicant_due_diligence_and_financial_capacity_questionnaire')}}</p>
          <upload-file v-if="GrantForm.initialized" v-model="GrantForm.files.technical.cnCoapplicantDueDiligenceAndFinancialCapacityQuestionnaire" :is-editable="GrantForm.isEditable && !GrantForm.disableConcept" :file-data="GrantForm.files.technical.cnCoapplicantDueDiligenceAndFinancialCapacityQuestionnaire" :size-limit="GrantForm.fileSizeLimit" section="technical.cnCoapplicantDueDiligenceAndFinancialCapacityQuestionnaire" type="cn" @file="fileAdded"></upload-file>
          </div>
          </div>

          <div class="border-bottom border-light">
            <div class="inline my-2">
          <p class="medium">{{$t('medium_grant_cn.document_upload_status_organisation')}}</p>
          <upload-file v-if="GrantForm.initialized" v-model="GrantForm.files.technical.cnStatusOrganisation" :is-editable="GrantForm.isEditable && !GrantForm.disableConcept" :file-data="GrantForm.files.technical.cnStatusOrganisation" :size-limit="GrantForm.fileSizeLimit" section="technical.cnStatusOrganisation" type="cn" @file="fileAdded"></upload-file>
          </div>
          </div>

          <div class="border-bottom border-light">
            <div class="inline my-2">
          <p class="medium">{{$t('medium_grant_cn.document_upload_lead_applicant_financial_identification_form')}}</p>
          <upload-file v-if="GrantForm.initialized" v-model="GrantForm.files.technical.cnLeadApplicantFinancialIdentification" :is-editable="GrantForm.isEditable && !GrantForm.disableConcept" :file-data="GrantForm.files.technical.cnLeadApplicantFinancialIdentification" :size-limit="GrantForm.fileSizeLimit" section="technical.cnLeadApplicantFinancialIdentification" type="cn" @file="fileAdded"></upload-file>
          </div>

          </div>
          
          <div class="border-bottom border-light">
            <div class="inline my-2">
          <p class="medium">{{$t('medium_grant_cn.document_upload_cv_project_leader')}}</p>
          <upload-file v-if="GrantForm.initialized" v-model="GrantForm.files.technical.cnCvProjectLeader" :allowed-file-type="'pdf'" :is-editable="GrantForm.isEditable && !GrantForm.disableConcept" :file-data="GrantForm.files.technical.cnCvProjectLeader" :size-limit="GrantForm.fileSizeLimit" section="technical.cnCvProjectLeader"></upload-file>
          </div>
          </div>
        
    </div>
    <!-- new-->
      </div>
    </div>
    <h4 class="card-title">{{$t('medium_grant.technical__2_organisational_info_co')}}</h4>
    <div class="row">
      <div class="col-lg-4">
        <label class="col-form-label">{{$t('medium_grant.technical__2_does_include_co')}}</label>
        <div>
          <div class="form-check form-check-radio form-check-inline">
            <radio name="technical.doesIncludeCo"
                   inline value="true"
                   v-validate="'required'"
                   :data-vv-as="$t('general.field')"
                   v-model="GrantForm.model.cnorgnization.doesIncludeCo"
                   :disabled="GrantForm.disableConcept"
            >
              {{$t('medium_grant.general__yes')}}
            </radio>
            <radio name="technical.doesIncludeCo" inline value="false" v-model="GrantForm.model.cnorgnization.doesIncludeCo" :disabled="GrantForm.disableConcept">
              {{$t('medium_grant.general__no')}}
            </radio>
          </div>
          <div>
            <label v-if="getError('cnorgnization.doesIncludeCo')" class="text-danger">{{getError('cnorgnization.doesIncludeCo')}}</label>
          </div>
        </div>

        <label class="mt-2 mb-4">{{$t('medium_grant.technical__2_does_include_co_if_yes')}}</label>

        <h4 class="card-title">{{$t('medium_grant.technical__2_organisational_info_co1')}}</h4>
        <div class="form-group">
          <label for="regionSelect">{{$t('medium_grant.technical__2_org_name_co_app')}}</label>
          <textarea
            class="form-control"
            name="technical.coApplicantOrgName"
            v-model="GrantForm.model.cnorgnization.coApplicantOrgName"
            :label="$t('medium_grant.technical__2_org_name_co_app')"
            :placeholder="$t('medium_grant.technical__2_org_name_co_app')"
            :disabled="GrantForm.disableConcept"
          >
          </textarea>
        </div>
        <div class="form-group">
          <label for="regionSelect">Short description of the organization</label>
          <textarea
            class="form-control"
            name="technical.coShortDescOrg"
            v-model="GrantForm.model.cnorgnization.coShortDescOrg"
            :label="$t('medium_grant.technical__2_short_desc_of_org')"
            :placeholder="$t('medium_grant.technical__2_short_desc_of_org')"
            :disabled="GrantForm.disableConcept"
          >
          </textarea>
        </div>
        <div class="form-group">
          <label for="regionSelect">{{$t('medium_grant.technical__2_role_in_project')}}</label>
          <textarea
            class="form-control"
            name="technical.roleInProject"
            v-model="GrantForm.model.cnorgnization.roleInProject"
            :label="$t('medium_grant.technical__2_role_in_project')"
            :placeholder="$t('medium_grant.technical__2_role_in_project')"
            :disabled="GrantForm.disableConcept"
          >
          </textarea>
        </div>
        <div class="form-group">
          <label for="regionSelect">{{$t('medium_grant.technical__2_amount_of_total_budget')}}</label>
          <textarea
            class="form-control"
            name="technical.amountOfTotalBudget"
            v-model="GrantForm.model.cnorgnization.amountOfTotalBudget"
            :label="$t('medium_grant.technical__2_amount_of_total_budget')"
            :placeholder="$t('medium_grant.technical__2_amount_of_total_budget')"
            :disabled="GrantForm.disableConcept"
          >
          </textarea>
        </div>
        <div class="form-group">
          <p class="small">Is an IUCN member?<i class="hover-instruction"></i></p>
          <div class="form-check form-check-radio form-check-inline">
            <radio name="coIucnMember" inline value="true" v-model="GrantForm.model.cnorgnization.coIucnMember" :disabled="GrantForm.disableConcept">
              {{$t('medium_grant.general__yes')}}
            </radio>
            <radio name="coIucnMember" inline value="false" v-model="GrantForm.model.cnorgnization.coIucnMember" :disabled="GrantForm.disableConcept">
              {{$t('medium_grant.general__no')}}
            </radio>
        </div>
        </div>

        <div v-if="orgCoApplicants" v-for="(orgCoApplicant, index) in orgCoApplicants" :key="index">
          <h4 class="card-title">
            {{$t('medium_grant.technical__2_organisational_info_co_only') + ' ' + (index+2)}}

            <base-button class="ml-2" @click="orgCoApplicants.splice(index, 1)" size="sm" icon type="danger" :disabled="GrantForm.disableConcept">
              <i class="fas fa-times"></i>
            </base-button>
          </h4>
          <div class="form-group">
          <textarea
            class="form-control"
            name="technical.coApplicantOrgName"
            v-model="orgCoApplicant.orgName"
            :label="$t('medium_grant.technical__2_org_name_co_app')"
            :placeholder="$t('medium_grant.technical__2_org_name_co_app')"
            :disabled="GrantForm.disableConcept"
          >
          </textarea>
          </div>
          <div class="form-group">
          <textarea
            class="form-control"
            name="technical.coShortDescOrg"
            v-model="orgCoApplicant.shortDesc"
            :label="$t('medium_grant.technical__2_short_desc_of_org')"
            :placeholder="$t('medium_grant.technical__2_short_desc_of_org')"
            :disabled="GrantForm.disableConcept"
          >
          </textarea>
          </div>
          <div class="form-group">
          <textarea
            class="form-control"
            name="technical.roleInProject"
            v-model="orgCoApplicant.role"
            :label="$t('medium_grant.technical__2_role_in_project')"
            :placeholder="$t('medium_grant.technical__2_role_in_project')"
            :disabled="GrantForm.disableConcept"
          >
          </textarea>
          </div>
          <div class="form-group">
          <textarea
            class="form-control"
            name="technical.amountOfTotalBudget"
            v-model="orgCoApplicant.budget"
            :label="$t('medium_grant.technical__2_amount_of_total_budget')"
            :placeholder="$t('medium_grant.technical__2_amount_of_total_budget')"
            :disabled="GrantForm.disableConcept"
          >
          </textarea>
          </div>
          <div class="form-group">
          <p class="small">Is an IUCN member?<i class="hover-instruction"></i></p>
          <div class="form-check form-check-radio form-check-inline">
            <radio name="coIucnMember" inline value="true" v-model="GrantForm.model.cnorgnization.coIucnMember" :disabled="GrantForm.disableConcept">
              {{$t('medium_grant.general__yes')}}
            </radio>
            <radio name="coIucnMember" inline value="false" v-model="GrantForm.model.cnorgnization.coIucnMember" :disabled="GrantForm.disableConcept">
              {{$t('medium_grant.general__no')}}
            </radio>
        </div>
        </div>
        </div>
        <base-button @click="addOrgCoApplicant" type="primary" class="btn-simple" size="sm" :disabled="GrantForm.disableConcept">
          + {{$t('medium_grant.technical__2_organisational_info_co_add')}}
        </base-button>

      </div>
    </div>
  </form>
</template>
<script>
  import {GrantForm} from "@/services";
  import {BaseCheckbox, BaseRadio} from 'src/components/index';
  import {EventBus} from '@/event-bus.js';

  export default {
    data() {
      return {
        GrantForm,
        orgCoApplicants: [],
        showText1: false,
        showText2: true,
        downloadFiles: [
          {
            en: '/files/en/MG/CN/Region/'+GrantForm.regionId+'/due_diligence.docx',
            fr: '/files/fr/MG/CN/Region/'+GrantForm.regionId+'/due_diligence.docx'
          },
        ]
      }
    },
    components: {
      BaseCheckbox,
      BaseRadio
    },
    methods: {
      getError(fieldName) {
        return this.errors.first(fieldName);
      },
      addOrgCoApplicant() {
        this.orgCoApplicants.push({
          orgName: '',
          shortDesc: '',
          role: '',
          budget: ''
        })
      },
      validate() {
        return this.$validator.validateAll().then(res => {
          this.$emit('on-validated', res, this.model);
          return res;
        });
      },
      fileAdded(file) {
                //EventBus.$emit('wizard-save-progress');
      }
    },
    mounted() {
      if (GrantForm.model.cnorgnization.orgCoApplicants) {
        this.orgCoApplicants = GrantForm.model.cnorgnization.orgCoApplicants;
      }
    },
    watch: {
      orgCoApplicants(value) {
        GrantForm.model.cnorgnization.orgCoApplicants = value;
      },
    },
  }
</script>
<style lang="scss" scoped>
  a {
    color: black;

    &:hover {
      text-decoration: underline;
    }
  }

  .inline{
    display: flex;
  justify-content: space-between;
  }

  .inline p{
width: 70%;
  }
</style>
